
/*
================================================================================

  Main

================================================================================
*/

import Navigation from './components/nav';
import Modal from './components/modal';
import Animations from './components/animations';
import ClientsSection from './sections/clients';
import MainHero from './sections/main-hero';
import CaseStudyPage from './pages/case-study';

// Components
Navigation.init();
Modal.init();
// Animations.init();

// Sections
ClientsSection.init();
MainHero.init();

// Pages
CaseStudyPage.init();



$(document).ready(function(){
  $('.slider').slick({
    slidesToShow: 1,
    infinite: false,
    slidesToScroll: 1,
    fade: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 8000,
    dots: true,

    customPaging: function(slick,index) {
      var targetImage = slick.$slides.eq(index).find('img').attr('src');
      return '<img src=" ' + targetImage + ' "/>';
  }
  });

  $('.slider-nav').slick({
    asNavFor: '.slider',
    centerMode: true,
    focusOnSelect: true,
    slidesToShow: 3,
    infinite: true,
    slidesToScroll: 1,
    arrows: false,
    dots: true
  });
});


